/** Where "Open in Planner" links point — the deployed SPA. */
export const APP_BASE = import.meta.env.VITE_APP_BASE ?? 'https://finance.flowza.ai';

/** Supabase project origin, for the add-in's own Edge Function calls. */
export const SUPABASE_URL =
  import.meta.env.VITE_SUPABASE_URL ?? 'https://ucjtxdmklhhhvayirwqe.supabase.co';

/**
 * Domain the board email addresses live on. Used only to render the
 * "forward this email to <board address>" hint for attachments — the add-in
 * never sends mail itself.
 */
export const INBOUND_DOMAIN = import.meta.env.VITE_INBOUND_DOMAIN ?? 'flowzaaimails.com';
